import { useDisclosure } from '@chakra-ui/react';
import ContractModal from '../../../../components/Contracts/ContractModal';
import { MLink } from '../../../../components/Monetize';

/**
 * The contract a renewal quote renews, before the quote is processed into a
 * contract of its own. Opens the contract over the quote rather than leaving it.
 */
export const QuotePriorContractLink = ({
  contractId,
}: {
  contractId: string;
}) => {
  const { open, onOpen, onClose } = useDisclosure();

  return (
    <>
      <MLink fontSize="sm" truncate maxWidth="200px" asChild>
        <button
          type="button"
          onClick={onOpen}
          data-testid="quote-prior-contract-link"
        >
          {contractId}
        </button>
      </MLink>
      {open && (
        <ContractModal isOpen contractId={contractId} onClose={onClose} />
      )}
    </>
  );
};
